import React from 'react'

const ScoreBar = ({ extraText, score }) => {
    const findProps = (score) => {
        if (score <= 50) {
            return {
                word: "Area for Improvement",
                description: "The practice is in the beginning stages and/or has not considered many of the aspects related to the concept.",
                className: "low-score"
            }
        } else if (score <= 75) {
            return {
                word: "Almost Ready",
                description: "The practice has considered some aspects related to the concept.",
                className: "medium-score"
            }
        } else {
            return {
                word: "Ready",
                description: "The practice has considered many aspects related to the concept.",
                className: "high-score"
            }
        }
    }

    const barProps = findProps(score)

    return (
        <div className="score-container">
            <h4 className="bold">{extraText}<span className={barProps.className}>{barProps.word}</span></h4>

            <p className="bottom-margin--sm no-print-margin">{barProps.description}</p>

            <div className="progress score-bar no-print" role="progressbar" tabIndex="0" aria-valuenow={`${score}`} aria-valuemin="0" aria-valuetext={barProps.word} aria-valuemax="100">
                <div className={`progress-meter ${barProps.className}`} style={{width: score + '%'}}></div>
            </div>
        </div>
    )
}

export default ScoreBar


// WEBPACK FOOTER //
// ./src/components/ScoreBar.js